<template>
  <section class="baseToolHeader">
    <div class="container">
      <div class="inner">
        <div class="mainImage">
          <slot name="image"></slot>
        </div>
        <div class="text">
          <h1>{{ title }}</h1>
          <p v-if="subText.length > 0" class="preamble">
            {{ subText }}
            <span v-if="showToolTip" class="toolTip" role="toolTip"></span>
          </p>
          <slot name="subHeader"></slot>
        </div>
        <div class="sponsorImage">
          <slot name="sponsorImage"></slot>
        </div>
      </div>
      <slot name="progressBar"> </slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    subText: {
      required: false,
      type: String,
    },
    showToolTip: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "~@web-components/scss/components/_baseToolHeader.scss";
</style>
